import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox, Input, Space, Spin } from "antd";
import { Icon } from "assets/icons";
import MenuLayout from "components/CustomFilterMenu/MenuLayout";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toLowerCaseNonAccentVietnamese } from "utils/helperFuncs";

const MENU_LAYOUT = { width: "300px" };

const OPTIONS_LIST_STYLE = {
  width: "100%",
  maxHeight: "200px",
  overflow: "auto",
  paddingBottom: "2px",
};

const LOAD_MORE_THRESHOLD_PX = 24;

export default function ProgramColumnFilter({
  options,
  loading,
  loadingMore,
  hasMore,
  onLoadMore,
  onFilter,
  defaultValue,
}) {
  const { t } = useTranslation();
  const [checkedList, setCheckedList] = useState(defaultValue || []);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    setCheckedList(defaultValue || []);
  }, [defaultValue]);

  const handleResetFilter = () => {
    setCheckedList([]);
    setSearchValue("");
    onFilter?.([]);
  };

  const handleApplyFilter = () => {
    onFilter?.(checkedList);
  };

  const handleChecked = (e) => {
    if (e?.target?.checked) {
      setCheckedList((prev) => [...prev, e?.target?.value]);
    } else {
      setCheckedList((prev) => prev?.filter((item) => item !== e?.target?.value));
    }
  };

  const handleOptionsScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    const nearBottom = scrollHeight - scrollTop - clientHeight < LOAD_MORE_THRESHOLD_PX;
    if (nearBottom && hasMore && !loadingMore && !loading) {
      onLoadMore?.();
    }
  };

  const filteredOptions = (options ?? []).filter((item) =>
    toLowerCaseNonAccentVietnamese(item.label)?.includes(toLowerCaseNonAccentVietnamese(searchValue))
  );

  const showInitialLoading = loading && !(options?.length > 0);

  return (
    <MenuLayout
      style={MENU_LAYOUT}
      applyFilter={handleApplyFilter}
      resetFilter={handleResetFilter}
      filterContent={
        <>
          <Input
            prefix={<FontAwesomeIcon icon={Icon.faSearch} />}
            placeholder={t("common.search")}
            allowClear
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <div style={OPTIONS_LIST_STYLE} onScroll={handleOptionsScroll}>
            {showInitialLoading ? (
              <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
                <Spin />
              </div>
            ) : (
              <>
                <Checkbox.Group value={checkedList}>
                  <Space direction="vertical" style={{ width: "100%" }}>
                    {filteredOptions.map((item) => (
                      <Checkbox key={item.value} value={item.value} onChange={handleChecked}>
                        {item.label}
                      </Checkbox>
                    ))}
                  </Space>
                </Checkbox.Group>
                {loadingMore && (
                  <div style={{ display: "flex", justifyContent: "center", padding: 8 }}>
                    <Spin size="small" />
                  </div>
                )}
              </>
            )}
          </div>
        </>
      }
    />
  );
}
